import styled from "styled-components";

export const _ProductIngredientAccordianListWrapper = styled.div<{}>(() => {
  return {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
  };
});
